// adapted from: https://git.hubteam.com/HubSpot/conversations-internal-schema/blob/24c061ac8fe4f3aee9b0a5f69a2d760a19563fd5/static/js/routing-rules/operators/routingRulesSetters.js

import curry from 'transmute/curry';
import pipe from 'transmute/pipe';
import setIn from 'transmute/setIn';
import { DISTRIBUTIONS } from '../constants/distributions';
import { DISTRIBUTION, FALLBACK, ROTATION_METHOD, TEAM_IDS, USER_IDS } from '../constants/keyPaths';
import { checkCanHaveFallback, checkHasTeamsOnly, checkHasUsersAndTeams, checkIsKeepAssignee, checkIsRoutingRuleConfig, getFallback } from './routingRulesGetters';
export const setFallback = setIn(FALLBACK);
const _setDistribution = curry((distribution, routingRules) => {
  if (checkIsKeepAssignee(routingRules)) {
    return routingRules;
  }
  let finalDistribution = DISTRIBUTIONS.BALANCED;
  let rotationMethod = DISTRIBUTIONS.LEAST_BUSY;
  if (distribution === DISTRIBUTIONS.RANDOM) {
    finalDistribution = DISTRIBUTIONS.RANDOM;
    rotationMethod = DISTRIBUTIONS.RANDOM;
  }
  let updatedRules = setIn(ROTATION_METHOD, rotationMethod, setIn(DISTRIBUTION, finalDistribution, routingRules));
  const fallback = getFallback(updatedRules);
  if (fallback && !checkIsKeepAssignee(fallback) && checkCanHaveFallback(updatedRules)) {
    const updatedFallback = _setDistribution(distribution, fallback);
    updatedRules = setFallback(updatedFallback, updatedRules);
  }
  return updatedRules;
});
export function setDistribution(distribution, routingRules) {
  return routingRules ? _setDistribution(distribution, routingRules) : _setDistribution(distribution);
}
export const setTeamIds = setIn(TEAM_IDS);
export const setUserIds = setIn(USER_IDS);
const _setUsersAndTeams = (userIds, teamIds) => pipe(setUserIds(userIds), setTeamIds(teamIds));
export const setUsersAndTeams = (routingRules, userIds, teamIds) => {
  if (!checkHasUsersAndTeams(routingRules)) {
    return routingRules;
  }
  const setIds = _setUsersAndTeams(userIds, teamIds);
  const currentFallback = getFallback(routingRules);
  if (checkCanHaveFallback(routingRules) && checkIsRoutingRuleConfig(currentFallback)) {
    return setFallback(setIds(currentFallback), routingRules);
  }
  return setIds(routingRules);
};
export const setTeamsOnly = (routingRules, teamIds) => {
  if (!checkHasTeamsOnly(routingRules)) {
    return routingRules;
  }
  const setIds = setTeamIds(teamIds);
  const currentFallback = getFallback(routingRules);
  if (checkCanHaveFallback(routingRules) && checkIsRoutingRuleConfig(currentFallback)) {
    return setFallback(setIds(currentFallback), routingRules);
  }
  return setIds(routingRules);
};